import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-edit',
  standalone: false,
  templateUrl: './subscription-edit.component.html',
  styleUrl: './subscription-edit.component.css'
})
export class SubscriptionEditComponent {

}
